
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2rynm", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $jmjWc = parcelRequire("jmjWc");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $io723 = parcelRequire("io723");


var $gz8ZY = parcelRequire("gz8ZY");


var $9wGTI = parcelRequire("9wGTI");


var $5s27v = parcelRequire("5s27v");











var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $1Zr9M = parcelRequire("1Zr9M");


var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $2W0qg = parcelRequire("2W0qg");


var $3gadb = parcelRequire("3gadb");


var $jZM59 = parcelRequire("jZM59");


var $5izcQ = parcelRequire("5izcQ");


var $inPa6 = parcelRequire("inPa6");


var $9x2sR = parcelRequire("9x2sR");


var $bedQP = parcelRequire("bedQP");





var $hXDOc = parcelRequire("hXDOc");


var $1NBp8 = parcelRequire("1NBp8");


var $1ytiN = parcelRequire("1ytiN");


var $eWwvy = parcelRequire("eWwvy");


var $d1wmn = parcelRequire("d1wmn");


var $joey7 = parcelRequire("joey7");





var $dPJCf = parcelRequire("dPJCf");





var $1kHsc = parcelRequire("1kHsc");








var $jrref = parcelRequire("jrref");

var $iXCQx = parcelRequire("iXCQx");


var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fdtRy = parcelRequire("fdtRy");

var $fNcP1 = parcelRequire("fNcP1");

var $aG6kF = parcelRequire("aG6kF");


var $gj7hi = parcelRequire("gj7hi");


var $fT2ta = parcelRequire("fT2ta");


var $lsxnT = parcelRequire("lsxnT");


var $3SChL = parcelRequire("3SChL");


var $3Awqk = parcelRequire("3Awqk");


var $2AgON = parcelRequire("2AgON");


var $35Nok = parcelRequire("35Nok");

var $5ecc3f8934f85e59$exports = {};
$5ecc3f8934f85e59$exports = new URL("Spaces.5611c4bd.gif", import.meta.url).toString();


var $db1162a25db39e60$exports = {};
$db1162a25db39e60$exports = new URL("Spaces-dark.4ceec6cd.gif", import.meta.url).toString();


var $537a412b2964f6f0$exports = {};
$537a412b2964f6f0$exports = new URL("Spaces-placeholder.5b3f2999.png", import.meta.url).toString();


var $a4e38a378b5824d3$exports = {};
$a4e38a378b5824d3$exports = new URL("Spaces-placeholder-dark.1c1d1b34.png", import.meta.url).toString();


const $f37e6d818dab503c$var$STEP_ID = 'nth-user-orientation-editor-space-spotlight';
const $f37e6d818dab503c$export$febddff29c5b0caa = ({ children: children })=>{
    const { reset: reset, next: next, currentStep: currentStep, progress: progress, hasInteracted: hasInteracted, active: active } = (0, $3SChL.useTour)($f37e6d818dab503c$var$STEP_ID);
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const isVisible = currentStep === $f37e6d818dab503c$var$STEP_ID;
    const { PopoverContent: PopoverContent } = (0, $lsxnT.useChoreographerAssets)();
    const currentSrc = (0, $35Nok.usePreloadGif)({
        gif: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($5ecc3f8934f85e59$exports))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($db1162a25db39e60$exports)))
        },
        placeholder: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($537a412b2964f6f0$exports))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($a4e38a378b5824d3$exports)))
        },
        skip: !active
    });
    const { handleNext: handleNext, handleDismiss: handleDismiss } = (0, $2AgON.useSpotlightAnalytics)({
        spotlightId: $f37e6d818dab503c$var$STEP_ID,
        isVisible: isVisible,
        onNext: next,
        onDismiss: reset
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jrref.Hide), {
        below: "md"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PopoverContent, {
        shouldDismissOnClickOutside: false,
        dismiss: handleDismiss,
        next: handleNext,
        placement: "right-end",
        offset: [
            0,
            24
        ],
        isVisible: isVisible,
        messageId: $f37e6d818dab503c$var$STEP_ID,
        messageType: hasInteracted ? 'transactional' : 'engagement'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
        entranceDirection: "left"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
            testId: $f37e6d818dab503c$var$STEP_ID
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, formatMessage((0, $3Awqk.editorSpaceSpotlight).headline)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdtRy.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: currentSrc,
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage((0, $3Awqk.editorSpaceSpotlight).body))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aG6kF.SpotlightStepCount), null, formatMessage((0, $3Awqk.spotlight).progress, progress)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), null, formatMessage((0, $3Awqk.spotlight).next))))))))));
};











var $hiS1z = parcelRequire("hiS1z");


var $euUgw = parcelRequire("euUgw");







var $dcJ7R = parcelRequire("dcJ7R");









var $eGUIL = parcelRequire("eGUIL");

const $39cc7021b1f9471a$export$c915848be66d4457 = (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { showExCoMessaging: t1 } = t0;
    const showExCoMessaging = t1 === undefined ? false : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { handleScrollToTop: handleScrollToTop } = (0, $eGUIL.useSideNavigation)();
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== handleScrollToTop) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "QuickAccess",
                    source: "spaceNavigation",
                    data: {
                        navigationLayer: "global",
                        navigationContainer: "sidebar",
                        navVersion: "4"
                    }
                }
            }).fire();
            handleScrollToTop();
        };
        $[0] = createAnalyticsEvent;
        $[1] = handleScrollToTop;
        $[2] = t2;
    } else t2 = $[2];
    const onClick = t2;
    const t3 = showExCoMessaging && $39cc7021b1f9471a$var$additionalOffset;
    let t4;
    if ($[3] !== t3) {
        t4 = [
            $39cc7021b1f9471a$var$pressableStyles,
            $39cc7021b1f9471a$var$stickyWrapper,
            t3
        ];
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            borderColor: "transparent"
        };
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euUgw))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)",
            size: "small"
        });
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.050",
            alignInline: "center",
            alignBlock: "center"
        }, t6, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            align: "center",
            size: "small",
            color: "color.text.subtle"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $39cc7021b1f9471a$var$i18n.scrollToTopButtonLabel)));
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== onClick || $[9] !== t4) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: t4,
            id: "scroll-to-top-button",
            onClick: onClick,
            style: t5
        }, t7);
        $[8] = onClick;
        $[9] = t4;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $39cc7021b1f9471a$var$offsetElement
        });
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[12] !== t8) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t8, t9);
        $[12] = t8;
        $[13] = t10;
    } else t10 = $[13];
    return t10;
};
const $39cc7021b1f9471a$var$offsetElement = (0, $ecnYn.xcss)({
    //this element keeps the spacing from he negative top margin tha hides the button
    height: '17px',
    width: `100%`,
    display: 'flex'
});
const $39cc7021b1f9471a$var$additionalOffset = (0, $ecnYn.xcss)({
    top: `76px`
});
const $39cc7021b1f9471a$var$stickyWrapper = (0, $ecnYn.xcss)({
    zIndex: 'card',
    // Needs to be at least z-index 2 to appear on top of Content and Shortcuts
    display: 'flex',
    position: 'sticky',
    top: `62px`,
    // @ts-ignore not assignable to type 'MarginSpace | GlobalValue | undefined'
    marginTop: `-50px`,
    //this hides the button underneath the space header until the ser scrolls down
    marginLeft: `auto`,
    marginRight: 'auto'
});
const $39cc7021b1f9471a$var$pressableStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderRadius: 'radius.full',
    paddingInline: 'space.100',
    alignItems: 'center',
    justifyContent: 'center',
    width: '125px',
    height: '32px',
    flexShrink: '0',
    boxShadow: 'elevation.shadow.overlay',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered'
    },
    ':active': {
        backgroundColor: 'elevation.surface.pressed'
    },
    ':focus': {
        outline: 'color.border.focused'
    }
});
const $39cc7021b1f9471a$var$i18n = (0, $h82at.defineMessages)({
    scrollToTopButtonLabel: {
        id: "side-navigation.global.scroll-to-top.button.label",
        defaultMessage: "Back to top"
    }
});














var $9VJDA = parcelRequire("9VJDA");


var $4kfV4 = parcelRequire("4kfV4");


var $1qfLF = parcelRequire("1qfLF");


var $lGgRw = parcelRequire("lGgRw");





var $bQm3c = parcelRequire("bQm3c");





const $476e0e4b3e7f33df$var$LazySpaceMoreActionsMenuContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "8HXE5",
    name: "LazySpaceMoreActionsMenuContent",
    loader: async ()=>(await (parcelRequire("8Ihu4"))).SpaceMoreActionsMenuContent
});

const $476e0e4b3e7f33df$var$LazyRestrictedSpaceMoreActionsMenuContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ZCfkL",
    name: "LazyRestrictedSpaceMoreActionsMenuContent",
    loader: async ()=>(await (parcelRequire("8Ihu4"))).RestrictedSpaceMoreActionsMenuContent
});
const $476e0e4b3e7f33df$export$cd488ab2b367186 = (props)=>{
    const $ = (0, $frIzR.c)(20);
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== props) {
        t0 = ()=>{
            props.setIsOpen(!props.isOpen);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "spaceMoreActionsMenu",
                    source: "spaceNavigation",
                    attributes: {
                        navigationLayer: "container",
                        navigationContainer: "sidebar",
                        navVersion: "4",
                        componentType: "fixedItemButton",
                        itemId: "meatballDropdown",
                        isSpaceAdmin: props.isSpaceAdmin
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    const onClick = t0;
    let t1;
    if ($[3] !== createAnalyticsEvent || $[4] !== props) {
        t1 = (selection)=>(e)=>{
                e.stopPropagation();
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "spaceMoreActionsMenuItem",
                        source: "spaceMoreActionsMenu",
                        attributes: {
                            navigationLayer: "container",
                            navigationContainer: "sidebar",
                            navVersion: "4",
                            componentType: "fixedItemAction",
                            itemId: selection,
                            isSpaceAdmin: props.isSpaceAdmin
                        }
                    }
                }).fire();
                props.setIsOpen(false);
            };
        $[3] = createAnalyticsEvent;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    const onMenuItemClicked = t1;
    let t2;
    if ($[6] !== props) {
        t2 = ()=>props.setIsOpen(false);
        $[6] = props;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== isLoggedIn || $[9] !== onMenuItemClicked || $[10] !== props) {
        t3 = ()=>isLoggedIn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($476e0e4b3e7f33df$var$LazySpaceMoreActionsMenuContent, {
                ...props,
                onMenuItemClicked: onMenuItemClicked
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($476e0e4b3e7f33df$var$LazyRestrictedSpaceMoreActionsMenuContent, {
                ...props,
                onMenuItemClicked: onMenuItemClicked
            });
        $[8] = isLoggedIn;
        $[9] = onMenuItemClicked;
        $[10] = props;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== onClick || $[13] !== props) {
        t4 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                ...triggerProps,
                icon: $476e0e4b3e7f33df$var$_temp,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $476e0e4b3e7f33df$var$i18n.moreActions),
                onClick: onClick,
                spacing: "compact",
                appearance: "subtle",
                isSelected: props.isOpen
            }), props.isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4kfV4.default), {
                testId: "space-more-actions-menu-blanket",
                isTinted: false,
                shouldAllowClickThrough: !props.isOpen,
                onBlanketClicked: ()=>props.setIsOpen(false)
            }) : null);
        $[12] = onClick;
        $[13] = props;
        $[14] = t4;
    } else t4 = $[14];
    let t5;
    if ($[15] !== props.isOpen || $[16] !== t2 || $[17] !== t3 || $[18] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            isOpen: props.isOpen,
            onClose: t2,
            content: t3,
            trigger: t4,
            placement: "right-start"
        });
        $[15] = props.isOpen;
        $[16] = t2;
        $[17] = t3;
        $[18] = t4;
        $[19] = t5;
    } else t5 = $[19];
    return t5;
};
const $476e0e4b3e7f33df$var$i18n = (0, $h82at.defineMessages)({
    moreActions: {
        id: "side-navigation.space-navigation.more-actions",
        defaultMessage: "More actions"
    }
});
function $476e0e4b3e7f33df$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
        ...iconProps,
        size: "small"
    });
}



const $6f43a2e4204022e9$var$ExternalCollaboratorsSpaceInformationMessageLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6-_i-",
    loader: async ()=>(await (parcelRequire("gYqak"))).ExternalCollaboratorsSpaceInformationMessage,
    name: 'ExternalCollaboratorsSpaceInformationMessage'
});
const $6f43a2e4204022e9$var$RemovedSpotlightTarget = (0, $bedQP.componentWithFG)('remove_unused_spotlight_targets', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children), ({ name: name, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: name
    }, children));
const $6f43a2e4204022e9$export$533fb76256978163 = (t0)=>{
    const $ = (0, $frIzR.c)(20);
    let containsExternalCollaborators;
    let isExternalCollaborator;
    let props;
    if ($[0] !== t0) {
        ({ isExternalCollaborator: isExternalCollaborator, containsExternalCollaborators: containsExternalCollaborators, ...props } = t0);
        $[0] = t0;
        $[1] = containsExternalCollaborators;
        $[2] = isExternalCollaborator;
        $[3] = props;
    } else {
        containsExternalCollaborators = $[1];
        isExternalCollaborator = $[2];
        props = $[3];
    }
    const [showExCoOnboardingNudge, setShowExCoOnboardingNudge] = (0, $42omo.useState)(false);
    const [onboardingStep, setOnboardingStep] = (0, $42omo.useState)(0);
    const { isLeftSidebarCollapsed: isLeftSidebarCollapsed } = (0, $jZM59.usePageLayoutResize)();
    const { isNewUser: isNewUser } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const showExCoMessaging = !isExternalCollaborator && containsExternalCollaborators;
    const showExCoModalOnboarding = !isNewUser && showExCoMessaging;
    const showExCoSpotlightOnboarding = !isNewUser && showExCoMessaging && showExCoOnboardingNudge && !isLeftSidebarCollapsed;
    let t1;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setShowExCoOnboardingNudge(true);
            setOnboardingStep(1);
        };
        $[4] = t1;
    } else t1 = $[4];
    const onGuestListOnboardingModalShown = t1;
    let t2;
    if ($[5] !== props || $[6] !== showExCoMessaging) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f43a2e4204022e9$var$SpaceHeaderInner, {
            ...props,
            showExCoMessaging: showExCoMessaging
        });
        $[5] = props;
        $[6] = showExCoMessaging;
        $[7] = t2;
    } else t2 = $[7];
    const header = t2;
    let t3;
    if ($[8] !== header || $[9] !== onboardingStep || $[10] !== showExCoSpotlightOnboarding) {
        t3 = showExCoSpotlightOnboarding && onboardingStep === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f43a2e4204022e9$var$SpaceHeaderExCoOnboarding, {
            header: header,
            onClose: ()=>setShowExCoOnboardingNudge(false)
        }) : header;
        $[8] = header;
        $[9] = onboardingStep;
        $[10] = showExCoSpotlightOnboarding;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== onboardingStep || $[13] !== props || $[14] !== showExCoModalOnboarding) {
        t4 = showExCoModalOnboarding && onboardingStep === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d1wmn.ExternalCollaboratorInSpaceNotify), {
            onModalClose: onGuestListOnboardingModalShown,
            spaceKey: props.spaceKey
        });
        $[12] = onboardingStep;
        $[13] = props;
        $[14] = showExCoModalOnboarding;
        $[15] = t4;
    } else t4 = $[15];
    let t5;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $joey7.GuestOnboardingModalLoadable), null);
        $[16] = t5;
    } else t5 = $[16];
    let t6;
    if ($[17] !== t3 || $[18] !== t4) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t3, t4, t5);
        $[17] = t3;
        $[18] = t4;
        $[19] = t6;
    } else t6 = $[19];
    return t6;
};
const $6f43a2e4204022e9$var$SpaceHeaderInner = (t0)=>{
    const $ = (0, $frIzR.c)(41);
    const { spaceId: spaceId, spaceName: spaceName, spaceKey: spaceKey, homepageId: homepageId, iconPath: iconPath, isStarred: isStarred, isWatched: isWatched, isSpaceAdmin: isSpaceAdmin, canManageSomeUsers: canManageSomeUsers, isPersonalSpace: isPersonalSpace, showExCoMessaging: showExCoMessaging, isSpaceArchived: isSpaceArchived, hasDeleteSpacePermission: hasDeleteSpacePermission, hasArchiveSpacePermission: hasArchiveSpacePermission } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isSelected = (0, $dPJCf.useRouteName)($6f43a2e4204022e9$var$isOnSpaceRouteArgs);
    let t1;
    if ($[0] !== homepageId || $[1] !== spaceKey) {
        t1 = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: spaceKey
        }, homepageId ? {
            query: {
                [(0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY]: homepageId
            }
        } : undefined);
        $[0] = homepageId;
        $[1] = spaceKey;
        $[2] = t1;
    } else t1 = $[2];
    const spaceOverviewHref = t1;
    let t2;
    if ($[3] !== showExCoMessaging || $[4] !== spaceKey) {
        t2 = showExCoMessaging ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            weight: "medium"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f43a2e4204022e9$var$ExternalCollaboratorsSpaceInformationMessageLoader, {
            analyticsSource: "spaceHeader",
            messageType: "IN_SPACE",
            shouldShowMessageIcon: false,
            shouldShowAdditionalMessageContext: false,
            spaceKey: spaceKey,
            isSubtle: true
        })) : undefined;
        $[3] = showExCoMessaging;
        $[4] = spaceKey;
        $[5] = t2;
    } else t2 = $[5];
    const description = t2;
    let t3;
    if ($[6] !== createAnalyticsEvent) {
        t3 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "spaceHeader",
                    source: "sideNavigation",
                    attributes: {
                        navVersion: 4
                    }
                }
            }).fire();
        };
        $[6] = createAnalyticsEvent;
        $[7] = t3;
    } else t3 = $[7];
    const onClick = t3;
    const [isMoreActionsOpen, setIsMoreActionsOpen] = (0, $42omo.useState)(false);
    let t4;
    if ($[8] !== canManageSomeUsers || $[9] !== hasArchiveSpacePermission || $[10] !== hasDeleteSpacePermission || $[11] !== isMoreActionsOpen || $[12] !== isSpaceAdmin || $[13] !== isSpaceArchived || $[14] !== isStarred || $[15] !== isWatched || $[16] !== spaceId || $[17] !== spaceKey) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $476e0e4b3e7f33df$export$cd488ab2b367186), {
            isOpen: isMoreActionsOpen,
            setIsOpen: setIsMoreActionsOpen,
            spaceId: spaceId,
            spaceKey: spaceKey,
            isStarred: isStarred,
            isWatched: isWatched,
            isSpaceAdmin: isSpaceAdmin,
            canManageSomeUsers: canManageSomeUsers,
            isSpaceArchived: isSpaceArchived,
            hasDeleteSpacePermission: hasDeleteSpacePermission,
            hasArchiveSpacePermission: hasArchiveSpacePermission
        });
        $[8] = canManageSomeUsers;
        $[9] = hasArchiveSpacePermission;
        $[10] = hasDeleteSpacePermission;
        $[11] = isMoreActionsOpen;
        $[12] = isSpaceAdmin;
        $[13] = isSpaceArchived;
        $[14] = isStarred;
        $[15] = isWatched;
        $[16] = spaceId;
        $[17] = spaceKey;
        $[18] = t4;
    } else t4 = $[18];
    const moreActionsMenu = t4;
    let t5;
    if ($[19] !== iconPath || $[20] !== isPersonalSpace || $[21] !== isSpaceAdmin || $[22] !== spaceId || $[23] !== spaceKey) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f43a2e4204022e9$var$EditableSpaceIcon, {
            spaceId: spaceId,
            spaceKey: spaceKey,
            iconPath: iconPath,
            isSpaceAdmin: isSpaceAdmin,
            isPersonalSpace: isPersonalSpace
        });
        $[19] = iconPath;
        $[20] = isPersonalSpace;
        $[21] = isSpaceAdmin;
        $[22] = spaceId;
        $[23] = spaceKey;
        $[24] = t5;
    } else t5 = $[24];
    let t6;
    if ($[25] !== description || $[26] !== isSelected || $[27] !== moreActionsMenu || $[28] !== onClick || $[29] !== spaceName || $[30] !== spaceOverviewHref || $[31] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
            href: spaceOverviewHref,
            isSelected: isSelected,
            onClick: onClick,
            elemBefore: t5,
            actions: moreActionsMenu,
            description: description
        }, spaceName);
        $[25] = description;
        $[26] = isSelected;
        $[27] = moreActionsMenu;
        $[28] = onClick;
        $[29] = spaceName;
        $[30] = spaceOverviewHref;
        $[31] = t5;
        $[32] = t6;
    } else t6 = $[32];
    let t7;
    if ($[33] !== spaceOverviewHref || $[34] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $6f43a2e4204022e9$var$stickyWrapper,
            "data-vc": "Nav4-space-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f43a2e4204022e9$var$SpaceHeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f37e6d818dab503c$export$febddff29c5b0caa), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f43a2e4204022e9$var$RemovedSpotlightTarget, {
            name: "nav4-spotlight-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXDOc.HoverPreloader), {
            name: "space-header",
            preloadUrl: spaceOverviewHref,
            preloadOptions: (0, $hXDOc.PreloadingPresets).onlyJSAndCriticalData
        }, t6)))));
        $[33] = spaceOverviewHref;
        $[34] = t6;
        $[35] = t7;
    } else t7 = $[35];
    let t8;
    if ($[36] !== showExCoMessaging) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $39cc7021b1f9471a$export$c915848be66d4457), {
            showExCoMessaging: showExCoMessaging
        });
        $[36] = showExCoMessaging;
        $[37] = t8;
    } else t8 = $[37];
    let t9;
    if ($[38] !== t7 || $[39] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t7, t8);
        $[38] = t7;
        $[39] = t8;
        $[40] = t9;
    } else t9 = $[40];
    return t9;
};
const $6f43a2e4204022e9$var$EditableSpaceIcon = (t0)=>{
    const $ = (0, $frIzR.c)(30);
    const { spaceId: spaceId, spaceKey: spaceKey, iconPath: iconPath, isSpaceAdmin: isSpaceAdmin, isPersonalSpace: isPersonalSpace } = t0;
    const intl = (0, $1cfRh.default)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { leftSidebarState: leftSidebarState, expandLeftSidebar: expandLeftSidebar } = (0, $jZM59.usePageLayoutResize)();
    const [isDialogOpen, setIsDialogOpen] = (0, $42omo.useState)(false);
    const [shouldRenderDialog, setShouldRenderDialog] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== iconPath) {
        t1 = iconPath ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
            src: iconPath,
            alt: "",
            "data-testid": "space-icon",
            "data-vc": "space-header-icon-image",
            "data-ssr-placeholder-ignored": true,
            role: "presentation",
            className: (0, $gMc0m.default)([
                "_2rko1qi0 _1bsb1tcg _4t3i1tcg"
            ])
        }) : null;
        $[0] = iconPath;
        $[1] = t1;
    } else t1 = $[1];
    const image = t1;
    const canEdit = isSpaceAdmin && !isPersonalSpace;
    if (!canEdit) return image;
    let t2;
    if ($[2] !== intl) {
        t2 = intl.formatMessage($6f43a2e4204022e9$var$i18n.editSpaceDetails);
        $[2] = intl;
        $[3] = t2;
    } else t2 = $[3];
    const editLabel = t2;
    let t3;
    if ($[4] !== createAnalyticsEvent || $[5] !== expandLeftSidebar || $[6] !== experienceTracker || $[7] !== leftSidebarState.isFlyoutOpen || $[8] !== spaceId || $[9] !== spaceKey) {
        t3 = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            experienceTracker.start({
                name: (0, $irVI7.EDIT_SPACE_LOGO_DETAILS_LOAD_EXPERIENCE),
                timeout: 10000
            });
            setShouldRenderDialog(true);
            setIsDialogOpen(true);
            if (leftSidebarState.isFlyoutOpen) expandLeftSidebar();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "editSpaceDetails",
                    source: "sideNavSpaceHeader",
                    containerType: "space",
                    containerId: spaceId,
                    attributes: {
                        navVersion: 4,
                        entryPoint: "sideNav",
                        spaceKey: spaceKey
                    }
                }
            }).fire();
        };
        $[4] = createAnalyticsEvent;
        $[5] = expandLeftSidebar;
        $[6] = experienceTracker;
        $[7] = leftSidebarState.isFlyoutOpen;
        $[8] = spaceId;
        $[9] = spaceKey;
        $[10] = t3;
    } else t3 = $[10];
    const onClick = t3;
    let t4;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setShouldRenderDialog(true);
        };
        $[11] = t4;
    } else t4 = $[11];
    const onFocus = t4;
    let t5;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{
            setShouldRenderDialog(true);
        };
        $[12] = t5;
    } else t5 = $[12];
    const onMouseEnter = t5;
    let t6;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setIsDialogOpen(true);
        };
        $[13] = t6;
    } else t6 = $[13];
    const onDialogOpen = t6;
    let t7;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>{
            setIsDialogOpen(false);
        };
        $[14] = t7;
    } else t7 = $[14];
    const onDialogClose = t7;
    let t8;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $6f43a2e4204022e9$var$editIconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
            label: "",
            color: "var(--ds-icon-inverse, #FFFFFF)"
        }));
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== editLabel || $[17] !== image || $[18] !== onClick) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: (0, $9wGTI.fg)("confluence_frontend_tokenize_border") ? $6f43a2e4204022e9$var$iconButton : $6f43a2e4204022e9$var$iconButtonFallback,
            "aria-label": editLabel,
            onClick: onClick,
            onFocus: onFocus,
            onMouseEnter: onMouseEnter
        }, image, t8);
        $[16] = editLabel;
        $[17] = image;
        $[18] = onClick;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] !== editLabel || $[21] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: editLabel
        }, t9);
        $[20] = editLabel;
        $[21] = t9;
        $[22] = t10;
    } else t10 = $[22];
    let t11;
    if ($[23] !== isDialogOpen || $[24] !== shouldRenderDialog || $[25] !== spaceKey) {
        t11 = shouldRenderDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eWwvy.EditSpaceLogo), {
            spaceKey: spaceKey,
            isOpen: isDialogOpen,
            onOpen: onDialogOpen,
            onClose: onDialogClose,
            entryPoint: "sideNav"
        });
        $[23] = isDialogOpen;
        $[24] = shouldRenderDialog;
        $[25] = spaceKey;
        $[26] = t11;
    } else t11 = $[26];
    let t12;
    if ($[27] !== t10 || $[28] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t10, t11);
        $[27] = t10;
        $[28] = t11;
        $[29] = t12;
    } else t12 = $[29];
    return t12;
};
const $6f43a2e4204022e9$var$isOnSpaceRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.SPACE_INDEX).name || routeName === (0, $1NBp8.SPACE_OVERVIEW).name
};
const $6f43a2e4204022e9$var$stickyWrapper = (0, $ecnYn.xcss)({
    position: 'sticky',
    top: 'space.0',
    zIndex: 'navigation' // Needs to be at least z-index 2 to appear on top of Content and Shortcuts
});
const $6f43a2e4204022e9$var$icon = null;
const $6f43a2e4204022e9$var$iconButton = (0, $ecnYn.xcss)({
    border: "var(--ds-space-0, 0px)",
    borderRadius: 'radius.small',
    background: 'none',
    padding: 'space.0',
    position: 'relative',
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    marginTop: 'space.050'
});
const $6f43a2e4204022e9$var$iconButtonFallback = (0, $ecnYn.xcss)({
    border: 'none',
    borderRadius: 'radius.small',
    background: 'none',
    padding: 'space.0',
    position: 'relative',
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    marginTop: 'space.050'
});
const $6f43a2e4204022e9$var$editIconWrapper = (0, $ecnYn.xcss)({
    position: 'absolute',
    height: '24px',
    width: '24px',
    top: 'space.0',
    left: 'space.0',
    padding: 'space.050',
    opacity: 0,
    transition: 'opacity 0.5s ease',
    ':hover': {
        opacity: 1
    },
    ':focus': {
        opacity: 1
    },
    backgroundColor: 'color.blanket',
    borderRadius: 'radius.medium'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f43a2e4204022e9$var$SpaceHeaderContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_ca0qutpp _n3td1skh _bfhkvuon",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});

const $6f43a2e4204022e9$var$SpaceHeaderExCoOnboarding = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "QrIC5",
    name: "SpaceHeaderExCoOnboarding",
    loader: async ()=>(await (parcelRequire("jAO76"))).SpaceHeaderExCoOnboarding
});
const $6f43a2e4204022e9$var$i18n = (0, $h82at.defineMessages)({
    editSpaceDetails: {
        id: "side-navigation.space-navigation.header.edit-space-details",
        defaultMessage: "Edit space details"
    }
});



var $ENihE = parcelRequire("ENihE");











var $euL71 = parcelRequire("euL71");














var $28oQf = parcelRequire("28oQf");

const $078c23c8ca6acb4f$export$5ff3b51f9b84be4d = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(15);
    const { links: links } = t0;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremiumEdition = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== isPremiumEdition || $[2] !== routeDataRef) {
        t1 = (itemId)=>()=>{
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "navigationItem",
                        actionSubjectId: "spaceNavigationItem",
                        source: "containerNavigation",
                        attributes: {
                            navigationLayer: "container",
                            itemId: itemId,
                            selectedItemPageContext: routeDataRef.current?.routeName,
                            navVersion: "4",
                            isPremiumEdition: isPremiumEdition
                        }
                    }
                }).fire();
            };
        $[0] = createAnalyticsEvent;
        $[1] = isPremiumEdition;
        $[2] = routeDataRef;
        $[3] = t1;
    } else t1 = $[3];
    const sendItemClickedAnalytics = t1;
    let t2;
    if ($[4] !== sendItemClickedAnalytics) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($078c23c8ca6acb4f$var$CalendarsLink, {
            key: "calendars-link",
            onClick: sendItemClickedAnalytics("calendars")
        });
        $[4] = sendItemClickedAnalytics;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== sendItemClickedAnalytics) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($078c23c8ca6acb4f$var$QuestionsLink, {
            key: "questions-link",
            onClick: sendItemClickedAnalytics("questions"),
            isLegacy: true
        });
        $[6] = sendItemClickedAnalytics;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== links || $[9] !== sendItemClickedAnalytics || $[10] !== t2 || $[11] !== t3) {
        const builtInitemsMapping = {
            [(0, $28oQf.CALENDARS_KEY)]: t2,
            [(0, $28oQf.QUESTIONS_KEY)]: t3,
            ...(0, $9wGTI.fg)("cc_editions_cq_native") && {
                [(0, $28oQf.QUESTIONS_NATIVE_KEY)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($078c23c8ca6acb4f$var$QuestionsLink, {
                    key: "questions-native-link",
                    onClick: sendItemClickedAnalytics("questions")
                })
            }
        };
        t4 = links.filter($078c23c8ca6acb4f$var$_temp).sort($078c23c8ca6acb4f$var$_temp2).map((t5)=>{
            const { webItemCompleteKey: webItemCompleteKey } = t5;
            return webItemCompleteKey && builtInitemsMapping[webItemCompleteKey] || null;
        });
        $[8] = links;
        $[9] = sendItemClickedAnalytics;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    const renderedLinks = t4;
    let t5;
    if ($[13] !== renderedLinks) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, renderedLinks);
        $[13] = renderedLinks;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
});

const $078c23c8ca6acb4f$var$CalendarsLink = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HaydR",
    name: "CalendarsLink",
    loader: async ()=>(await (parcelRequire("bRsEt"))).CalendarsLink
});

const $078c23c8ca6acb4f$var$QuestionsLink = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8uaMN",
    name: "QuestionsLink",
    loader: async ()=>(await (parcelRequire("8Ai3e"))).QuestionsLink
});
function $078c23c8ca6acb4f$var$_temp(link) {
    return Boolean(link && !link.hidden);
}
function $078c23c8ca6acb4f$var$_temp2(a, b) {
    return Number(a.position) - Number(b.position);
}



var $aWrnw = parcelRequire("aWrnw");


const $c83507daffd5a949$var$ErrorView = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "NxOnG",
    name: "ErrorView",
    loader: async ()=>(await (parcelRequire("4vXZ9"))).ErrorView
});

const $c83507daffd5a949$var$SpaceApps = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MuuSQ",
    name: "SpaceApps",
    loader: async ()=>(await (parcelRequire("hXk9Y"))).SpaceApps
});
const $c83507daffd5a949$var$spaceLinksStyles = null;
const $c83507daffd5a949$var$SidebarContent = /*#__PURE__*/ (0, $42omo.memo)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_n3tdze3t _kqswh2mm _19pk1wug",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}));
const $c83507daffd5a949$var$separatorStyles = null;
const $c83507daffd5a949$var$separatorStylesFallback = null;
const $c83507daffd5a949$export$ec7f7d400376dc53 = (t0)=>{
    const $ = (0, $frIzR.c)(50);
    const { navigationProps: navigationProps, errorProps: errorProps, spaceDetails: spaceDetails } = t0;
    const { loading: loading, hasSpace: hasSpace, space: space, spaceKey: spaceKey, homepageId: homepageId, main: main, quick: quick, isSpaceAdmin: isSpaceAdmin, isBlogNavigation: isBlogNavigation, blogsHidden: blogsHidden, pageTreeFinishedLoading: pageTreeFinishedLoading, onDragDropSuccess: onDragDropSuccess, showShortcutsSection: showShortcutsSection, shouldRenderSpaceApps: shouldRenderSpaceApps, allAppLinks: allAppLinks, allVisibleAppLinks: allVisibleAppLinks, loadingForgeApps: loadingForgeApps, onContentTreeLoadComplete: onContentTreeLoadComplete } = navigationProps;
    const { unhandledError: unhandledError, hasRestrictedError: hasRestrictedError, hasNotFoundError: hasNotFoundError, anonymousAccessQueryError: anonymousAccessQueryError } = errorProps;
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    if (unhandledError || hasRestrictedError || hasNotFoundError || anonymousAccessQueryError || !loading && !hasSpace) {
        const t1 = unhandledError || anonymousAccessQueryError;
        let t2;
        if ($[0] !== hasNotFoundError || $[1] !== hasRestrictedError || $[2] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c83507daffd5a949$var$ErrorView, {
                unhandledError: t1,
                hasRestrictedError: hasRestrictedError,
                hasNotFoundError: hasNotFoundError
            });
            $[0] = hasNotFoundError;
            $[1] = hasRestrictedError;
            $[2] = t1;
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    let t1;
    if ($[4] !== spaceDetails) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f43a2e4204022e9$export$533fb76256978163), spaceDetails);
        $[4] = spaceDetails;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== loading) {
        t2 = !loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.APP_NAV_CONTAINER_EXPERIENCE)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null);
        $[6] = loading;
        $[7] = t2;
    } else t2 = $[7];
    const t3 = spaceDetails?.spaceName;
    const t4 = spaceDetails?.iconPath;
    let t5;
    if ($[8] !== blogsHidden || $[9] !== homepageId || $[10] !== isBlogNavigation || $[11] !== isSpaceAdmin || $[12] !== loading || $[13] !== onContentTreeLoadComplete || $[14] !== onDragDropSuccess || $[15] !== pageTreeFinishedLoading || $[16] !== quick || $[17] !== showShortcutsSection || $[18] !== space || $[19] !== spaceKey || $[20] !== t3 || $[21] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5s27v.CommonSpaceNavigationContent), {
            showShortcutsSection: showShortcutsSection,
            space: space,
            spaceKey: spaceKey,
            quick: quick,
            homepageId: homepageId,
            loading: loading,
            isSpaceAdmin: isSpaceAdmin,
            isBlogNavigation: isBlogNavigation,
            blogsHidden: blogsHidden,
            pageTreeFinishedLoading: pageTreeFinishedLoading,
            onDragDropSuccess: onDragDropSuccess,
            onContentTreeLoadComplete: onContentTreeLoadComplete,
            spaceName: t3,
            iconPath: t4
        });
        $[8] = blogsHidden;
        $[9] = homepageId;
        $[10] = isBlogNavigation;
        $[11] = isSpaceAdmin;
        $[12] = loading;
        $[13] = onContentTreeLoadComplete;
        $[14] = onDragDropSuccess;
        $[15] = pageTreeFinishedLoading;
        $[16] = quick;
        $[17] = showShortcutsSection;
        $[18] = space;
        $[19] = spaceKey;
        $[20] = t3;
        $[21] = t4;
        $[22] = t5;
    } else t5 = $[22];
    let t6;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $gMc0m.default)([
            "_18s8ze3t _1yt4ze3t _qtt8glyw _vjgoze3t"
        ]);
        $[23] = t6;
    } else t6 = $[23];
    let t7;
    if ($[24] !== loading || $[25] !== main) {
        t7 = loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ENihE.ContainerSkeleton), {
            header: false
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $078c23c8ca6acb4f$export$5ff3b51f9b84be4d), {
            links: main
        });
        $[24] = loading;
        $[25] = main;
        $[26] = t7;
    } else t7 = $[26];
    let t8;
    if ($[27] !== t6 || $[28] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", {
            "data-testid": "space-links",
            className: t6
        }, t7);
        $[27] = t6;
        $[28] = t7;
        $[29] = t8;
    } else t8 = $[29];
    let t9;
    if ($[30] !== allAppLinks || $[31] !== allVisibleAppLinks || $[32] !== isSpaceAdmin || $[33] !== loading || $[34] !== loadingForgeApps || $[35] !== shouldRenderSpaceApps || $[36] !== spaceKey) {
        t9 = !loading && !loadingForgeApps && shouldRenderSpaceApps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
            metric: (0, $aWrnw.SPACE_APPS_METRIC)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c83507daffd5a949$var$SpaceApps, {
            spaceKey: spaceKey,
            isSpaceAdmin: isSpaceAdmin,
            allAppLinks: allAppLinks,
            allVisibleAppLinks: allVisibleAppLinks
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null);
        $[30] = allAppLinks;
        $[31] = allVisibleAppLinks;
        $[32] = isSpaceAdmin;
        $[33] = loading;
        $[34] = loadingForgeApps;
        $[35] = shouldRenderSpaceApps;
        $[36] = spaceKey;
        $[37] = t9;
    } else t9 = $[37];
    let t10;
    if ($[38] !== t2 || $[39] !== t5 || $[40] !== t8 || $[41] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c83507daffd5a949$var$SidebarContent, {
            "data-vc": "space-navigation-sidebar-content"
        }, t2, t5, t8, t9);
        $[38] = t2;
        $[39] = t5;
        $[40] = t8;
        $[41] = t9;
        $[42] = t10;
    } else t10 = $[42];
    let t11;
    if ($[43] !== isNav4Enabled || $[44] !== loading) {
        t11 = isNav4Enabled && !loading && (0, $9wGTI.fg)("nav4_global_links_confluence") && ((0, $9wGTI.fg)("confluence_frontend_tokenize_border") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("hr", {
            role: "presentation",
            id: "space-header-top-divider",
            className: (0, $gMc0m.default)([
                "_19itze3t _195gxmi2 _n7zlia51 _19pkutpp"
            ])
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("hr", {
            role: "presentation",
            id: "space-header-top-divider",
            className: (0, $gMc0m.default)([
                "_19itidpf _195gxmi2 _n7zlia51 _19pkutpp"
            ])
        }));
        $[43] = isNav4Enabled;
        $[44] = loading;
        $[45] = t11;
    } else t11 = $[45];
    let t12;
    if ($[46] !== t1 || $[47] !== t10 || $[48] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1, t10, t11);
        $[46] = t1;
        $[47] = t10;
        $[48] = t11;
        $[49] = t12;
    } else t12 = $[49];
    return t12;
};
module.exports["SpaceNavigationContent"] = $c83507daffd5a949$export$ec7f7d400376dc53;

});

parcelRegister("jZM59", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $e6220385bdb59eee$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true,
    hasInit: false
};
const $e6220385bdb59eee$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $42omo.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $ee7An.default),
    collapseLeftSidebar: (0, $ee7An.default),
    leftSidebarState: $e6220385bdb59eee$var$leftSidebarState,
    setLeftSidebarState: (0, $ee7An.default),
    toggleLeftSidebar: (0, $ee7An.default)
});
const $e6220385bdb59eee$export$10c7104037a7af62 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState, ...context } = (0, $42omo.useContext)($e6220385bdb59eee$export$aa5a712eea4c2ae8);
    return context;
};
const $e6220385bdb59eee$export$94561f6055639ef7 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState } = (0, $42omo.useContext)($e6220385bdb59eee$export$aa5a712eea4c2ae8);
    (0, $42omo.useEffect)(()=>{
        setLeftSidebarState((current)=>({
                ...current,
                flyoutLockCount: current.flyoutLockCount + 1
            }));
        return ()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    flyoutLockCount: current.flyoutLockCount - 1
                }));
        };
    }, [
        setLeftSidebarState
    ]);
};
module.exports["usePageLayoutResize"] = $e6220385bdb59eee$export$10c7104037a7af62;
module.exports["useLeftSidebarFlyoutLock"] = $e6220385bdb59eee$export$94561f6055639ef7;

});

parcelRegister("9x2sR", function(module, exports) {
/* link-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3hoG4 = parcelRequire("3hoG4");


var $3654r = parcelRequire("3654r");


var $eLJ8w = parcelRequire("eLJ8w");


var $8njHX = parcelRequire("8njHX");


var $fDC7w = parcelRequire("fDC7w");

const $a9268ffbf811ea39$var$listItemStyles = {
    root: "_10m98stt"
};
const $a9268ffbf811ea39$var$LinkMenuItemNoRef = ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const itemRef = (0, $42omo.useRef)(null);
    (0, $fDC7w.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: isSelected ?? false
    });
    const ref = (0, $42omo.useMemo)(()=>{
        return (0, $3654r.default)([
            itemRef,
            listItemRef ?? null
        ]);
    }, [
        itemRef,
        listItemRef
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eLJ8w.ListItem), {
        ref: ref,
        xcss: $a9268ffbf811ea39$var$listItemStyles.root,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8njHX.MenuItemBase), {
            testId: testId,
            description: description,
            actions: actions,
            elemAfter: elemAfter,
            // TODO Always use "open in new window" icon when `openInNewWindow` prop is true
            elemBefore: elemBefore,
            href: href,
            target: target,
            actionsOnHover: actionsOnHover,
            isSelected: isSelected,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
};
const $a9268ffbf811ea39$export$d2cad7a1cce7b35f = (0, $3hoG4.default)($a9268ffbf811ea39$var$LinkMenuItemNoRef);
module.exports["LinkMenuItem"] = $a9268ffbf811ea39$export$d2cad7a1cce7b35f;

});

parcelRegister("3hoG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c95e6dd3d3e2d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $b38c95e6dd3d3e2d$export$2e2bcd8739ae039 = (0, $42omo.forwardRef);

});

parcelRegister("fDC7w", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $6BXcn = parcelRequire("6BXcn");

function $4023ab33a3161118$var$scrollMenuItemIntoView(element) {
    /**
	 * If [scrollIntoViewIfNeeded](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded) is available,
	 * we are using it to scroll the element into view _in the center_ of the scroll container. Because it is a non-standard method
	 * and not available on all browsers (currently not supported in Firefox), we are using it for progressive enhancement.
	 *
	 * Otherwise, we are falling back to [scrollIntoView](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView).
	 */ const elementWithScrollMethod = element;
    if (typeof elementWithScrollMethod.scrollIntoViewIfNeeded === 'function') {
        elementWithScrollMethod.scrollIntoViewIfNeeded(true);
        return;
    }
    // JSDOM does not support scrollIntoView, so defensively using it (see https://github.com/jsdom/jsdom/issues/1695)
    element.scrollIntoView?.({
        // We are using `nearest` to prevent scrolling on user interaction when the menu item is already in view.
        block: 'nearest'
    });
}
function $4023ab33a3161118$export$2c52ec851fcc6058({ elementRef: elementRef, isSelected: isSelected }) {
    const areAllAncestorsExpanded = (0, $6BXcn.useAreAllAncestorsExpanded)();
    const waitingStateRef = (0, $42omo.useRef)({
        type: 'waiting-to-be-selected-and-all-ancestors-expanded'
    });
    (0, $42omo.useEffect)(()=>{
        if (waitingStateRef.current.type === 'waiting-to-be-selected-and-all-ancestors-expanded') {
            const shouldScroll = areAllAncestorsExpanded && isSelected;
            if (!shouldScroll) return;
            const element = elementRef.current;
            (0, $dRnqM.default)(element, 'Element ref must be set');
            $4023ab33a3161118$var$scrollMenuItemIntoView(element);
            // Now that we are scrolled the menu item into view, we need to wait for the menu item to
            // be unselected before checking again.
            waitingStateRef.current.type = 'waiting-to-be-unselected';
            return;
        }
        if (waitingStateRef.current.type === 'waiting-to-be-unselected') {
            if (!isSelected) waitingStateRef.current.type = 'waiting-to-be-selected-and-all-ancestors-expanded';
            return;
        }
    }, [
        areAllAncestorsExpanded,
        elementRef,
        isSelected
    ]);
}
module.exports["useScrollMenuItemIntoView"] = $4023ab33a3161118$export$2c52ec851fcc6058;

});

parcelRegister("bedQP", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");

const $9aeacd26f36a9957$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $9aeacd26f36a9957$export$cf56d0f54cfcce4;

});

parcelRegister("9JpPs", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $c712b10e1cbb5738$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $c712b10e1cbb5738$export$6e8ea24b15199873;

});

parcelRegister("hXDOc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $42omo.useRef)(null);
    const preloadRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Do not proceed to the next stage if only JS preloading is enabled
        if (preloadOptions?.preloadingMode === "onlyJS") return;
        // Trigger next preloading stage either if everything is enabled or if critical data preloading
        // is enabled and the corresponding feature flag is enabled.
        const shouldPreload = preloadOptions?.preloadingMode === "everything" ? true : preloadOptions?.preloadingMode === "onlyJSAndCriticalData" && (0, $9wGTI.fg)('confluence_preload_critical_data');
        if (!shouldPreload) return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $42omo.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    // Helper to chain child handlers with hover-preloader handlers
    const chain = (...fns)=>(...args)=>{
            fns.forEach((fn)=>{
                if (fn) fn(...args);
            });
        };
    const wrappedChild = /*#__PURE__*/ (0, $42omo.isValidElement)(children) ? /*#__PURE__*/ (0, $42omo.cloneElement)(children, {
        onMouseEnter: chain(children.props.onMouseEnter, onMouseEnter),
        onFocus: chain(children.props.onFocus, onMouseEnter),
        onMouseLeave: chain(children.props.onMouseLeave, onMouseLeave),
        onBlur: chain(children.props.onBlur, onMouseLeave),
        onMouseDown: chain(children.props.onMouseDown, onMouseDown)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader"
    }, wrappedChild);
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) {
        if ((0, $6mKj3.expVal)('platform_editor_hydratable_ui', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-vc": `hover-preloader-${props.name}`,
            "data-testid": "hover-preloader"
        }, props.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});

parcelRegister("eWwvy", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $49b80c0b2fd2c306$export$9c32b7bc3af8de64 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "5liJC",
    name: "EditSpaceLogo",
    loader: async ()=>(await (parcelRequire("fIdAJ"))).EditSpaceLogo
});
module.exports["EditSpaceLogo"] = $49b80c0b2fd2c306$export$9c32b7bc3af8de64;

});

parcelRegister("fIdAJ", function(module, exports) {

let $b7058211b83db610$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b7058211b83db610$var$load("kyxdN").then(()=>parcelRequire('asonV'));

});

parcelRegister("jrref", function(module, exports) {
/* hide.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $7ca6755ada461d2d$var$styles = {
    'above.xs': "_114bglyw",
    'above.sm': "_181nglyw",
    'above.md': "_dm25glyw",
    'above.lg': "_je3oglyw",
    'above.xl': "_1uxvglyw",
    'below.xs': "_1m0aglyw",
    'below.sm': "_sugaglyw",
    'below.md': "_1mjbglyw",
    'below.lg': "_liwcglyw",
    'below.xl': "_14wzglyw"
};
const $7ca6755ada461d2d$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(AsElement, {
        className: (0, $gMc0m.default)([
            above && $7ca6755ada461d2d$var$styles[`above.${above}`],
            below && $7ca6755ada461d2d$var$styles[`below.${below}`],
            xcss
        ]),
        children: children
    });
};
module.exports["Hide"] = $7ca6755ada461d2d$export$bed28288a051538;

});

parcelRegister("lsxnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $42omo.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $42omo.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $42omo.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("i3jcY", function(module, exports) {

var $4VJDS = parcelRequire("4VJDS");


const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    if ((0, $4VJDS.default).isKillSwitchOn('cc_e2e_stable_ui')) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return window.location.search.includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
    return false;
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    ChoreographedComponent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightTarget: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("3SChL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $751fcd22fac4dec6$export$7a357837346c6789 = {
    editor: [
        'nth-user-orientation-editor-space-spotlight',
        'nth-user-orientation-editor-for-you-spotlight',
        'nth-user-orientation-editor-bpqa-spotlight'
    ]
};
const $751fcd22fac4dec6$var$detectTour = (renderedSpotlights)=>{
    // Find the first tour where all required spotlights are registered
    for (const [tour, spotlights] of Object.entries($751fcd22fac4dec6$export$7a357837346c6789)){
        if (spotlights.every((spotlight)=>renderedSpotlights.has(spotlight))) return tour;
    }
    return null;
};
const $751fcd22fac4dec6$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        active: false,
        step: 0,
        renderedSpotlights: new Set(),
        hasInteracted: false
    },
    actions: {
        activate: ()=>({ setState: setState })=>{
                setState({
                    active: true,
                    step: 0
                });
            },
        reset: ()=>({ setState: setState })=>{
                setState({
                    active: false,
                    step: 0,
                    hasInteracted: false
                });
            },
        next: ()=>({ setState: setState, getState: getState })=>{
                const nextStep = Math.min(getState().step + 1, 2);
                setState({
                    step: nextStep,
                    hasInteracted: true
                });
            },
        back: ()=>({ setState: setState, getState: getState })=>{
                const prevStep = Math.max(getState().step - 1, 0);
                setState({
                    step: prevStep,
                    hasInteracted: true
                });
            },
        registerSpotlight: ({ spotlightId: spotlightId })=>({ setState: setState, getState: getState })=>{
                const newRegistered = new Set(getState().renderedSpotlights);
                newRegistered.add(spotlightId);
                setState({
                    renderedSpotlights: newRegistered
                });
            },
        deregisterSpotlight: ({ spotlightId: spotlightId })=>({ setState: setState, getState: getState })=>{
                const newRegistered = new Set(getState().renderedSpotlights);
                newRegistered.delete(spotlightId);
                setState({
                    renderedSpotlights: newRegistered
                });
            }
    },
    name: 'experiment-nth-user-orientation-store'
});
const $751fcd22fac4dec6$export$6d3060c9729a9bf7 = (0, $9zUhf.createStateHook)($751fcd22fac4dec6$var$Store);
const $751fcd22fac4dec6$export$31ec7099503725e8 = (0, $9zUhf.createActionsHook)($751fcd22fac4dec6$var$Store);
const $751fcd22fac4dec6$export$e9b94d8bc34db24 = (spotlightId)=>{
    const { next: next, back: back, reset: reset, registerSpotlight: registerSpotlight, deregisterSpotlight: deregisterSpotlight } = $751fcd22fac4dec6$export$31ec7099503725e8();
    const { step: step, active: active, renderedSpotlights: renderedSpotlights, hasInteracted: hasInteracted } = $751fcd22fac4dec6$export$6d3060c9729a9bf7();
    // Auto-register/deregister the spotlight when spotlights use this hook. This way
    // we can keep track of which spotlights are currently rendered, and use that list
    // to figure out if the user is eligible for a tour.
    (0, $42omo.useEffect)(()=>{
        registerSpotlight({
            spotlightId: spotlightId
        });
        return ()=>{
            deregisterSpotlight({
                spotlightId: spotlightId
            });
        };
    }, [
        spotlightId,
        registerSpotlight,
        deregisterSpotlight
    ]);
    const detectedTour = (0, $42omo.useMemo)(()=>$751fcd22fac4dec6$var$detectTour(renderedSpotlights), [
        renderedSpotlights
    ]);
    if (!active || !detectedTour) return {
        reset: reset,
        back: back,
        next: next,
        currentStep: null,
        progress: {
            step: 0,
            steps: 0
        },
        hasInteracted: hasInteracted,
        active: active
    };
    return {
        reset: reset,
        back: back,
        next: next,
        currentStep: $751fcd22fac4dec6$export$7a357837346c6789[detectedTour][step],
        progress: {
            step: step + 1,
            steps: detectedTour ? $751fcd22fac4dec6$export$7a357837346c6789[detectedTour].length : 0
        },
        hasInteracted: hasInteracted,
        active: active
    };
};
module.exports["useNthUserOrientationState"] = $751fcd22fac4dec6$export$6d3060c9729a9bf7;
module.exports["useNthUserOrientationActions"] = $751fcd22fac4dec6$export$31ec7099503725e8;
module.exports["useTour"] = $751fcd22fac4dec6$export$e9b94d8bc34db24;

});

parcelRegister("3Awqk", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $90247d71b6534bef$export$ce22f6f6b0034afd = (0, $h82at.defineMessages)({
    next: {
        id: "experiment-nth-user-orientation.spotlight.next",
        defaultMessage: "Next"
    },
    back: {
        id: "experiment-nth-user-orientation.spotlight.back",
        defaultMessage: "Back"
    },
    done: {
        id: "experiment-nth-user-orientation.spotlight.done",
        defaultMessage: "Done"
    },
    dismiss: {
        id: "experiment-nth-user-orientation.spotlight.dismiss",
        defaultMessage: "Dismiss Tour"
    },
    progress: {
        id: "experiment-nth-user-orientation.spotlight.progress",
        defaultMessage: "{step} of {steps}"
    }
});
const $90247d71b6534bef$export$9a4454cd199ce080 = (0, $h82at.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorSpaceSpotlight.headline",
        defaultMessage: "Your space, your start"
    },
    body: {
        id: "experiment-nth-user-orientation.editorSpaceSpotlight.body",
        defaultMessage: "This is your personal space. Create more to organize your team\u2019s work."
    }
});
const $90247d71b6534bef$export$252e22890fb2efa6 = (0, $h82at.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorForYouSpotlight.headline",
        defaultMessage: "Catch up on team activity here"
    },
    body: {
        id: "experiment-nth-user-orientation.editorForYouSpotlight.body",
        defaultMessage: "See recent pages, team updates, and quick links tailored for you."
    }
});
const $90247d71b6534bef$export$6794fada8079fe55 = (0, $h82at.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorBpqaSpotlight.headline",
        defaultMessage: "Now let\u2019s create your first page!"
    },
    body: {
        id: "experiment-nth-user-orientation.editorBpqaSpotlight.body",
        defaultMessage: "With a template, a page is a click away. Hover on one for a preview."
    }
});
module.exports["spotlight"] = $90247d71b6534bef$export$ce22f6f6b0034afd;
module.exports["editorSpaceSpotlight"] = $90247d71b6534bef$export$9a4454cd199ce080;
module.exports["editorForYouSpotlight"] = $90247d71b6534bef$export$252e22890fb2efa6;
module.exports["editorBpqaSpotlight"] = $90247d71b6534bef$export$6794fada8079fe55;

});

parcelRegister("2AgON", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $3c36b21fe0d55bcd$var$SPOTLIGHT_ACTION_SUBJECT_IDS = {
    'nth-user-orientation-editor-space-spotlight': 'nthUserOrientationEditorSpaceSpotlight',
    'nth-user-orientation-editor-for-you-spotlight': 'nthUserOrientationEditorForYouSpotlight',
    'nth-user-orientation-editor-bpqa-spotlight': 'nthUserOrientationEditorBpqaSpotlight'
};
function $3c36b21fe0d55bcd$export$b54fada573f13a91({ spotlightId: spotlightId, isVisible: isVisible, onNext: onNext, onBack: onBack, onDismiss: onDismiss }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // Fire render event when spotlight becomes visible
    (0, $42omo.useEffect)(()=>{
        if (isVisible) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'rendered',
                actionSubject: 'spotlight',
                actionSubjectId: $3c36b21fe0d55bcd$var$SPOTLIGHT_ACTION_SUBJECT_IDS[spotlightId],
                source: 'nth-user-orientation'
            }
        }).fire();
    }, [
        isVisible,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleNext = (0, $42omo.useCallback)(()=>{
        if (onNext) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'next',
                    source: spotlightId
                }
            }).fire();
            onNext();
        }
    }, [
        onNext,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleBack = (0, $42omo.useCallback)(()=>{
        if (onBack) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'back',
                    source: spotlightId
                }
            }).fire();
            onBack();
        }
    }, [
        onBack,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismissTour',
                source: spotlightId
            }
        }).fire();
        onDismiss();
    }, [
        onDismiss,
        createAnalyticsEvent,
        spotlightId
    ]);
    return {
        handleNext: onNext ? handleNext : undefined,
        handleBack: onBack ? handleBack : undefined,
        handleDismiss: handleDismiss
    };
}
module.exports["useSpotlightAnalytics"] = $3c36b21fe0d55bcd$export$b54fada573f13a91;

});

parcelRegister("35Nok", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cOrQJ = parcelRequire("cOrQJ");

const $cd2e96a49affba4b$export$4b64aca38e15f2eb = ({ gif: gif, placeholder: placeholder, skip: skip = false })=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const gifSrc = gif[colorMode ?? 'light'];
    const placeholderSrc = placeholder[colorMode ?? 'light'];
    const [isReady, setIsReady] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        setIsReady(false);
        const image = new Image();
        image.onload = ()=>{
            setIsReady(true);
        };
        image.onerror = ()=>{
            setIsReady(false);
        };
        image.src = gifSrc;
        // If the image has already loaded (cached), handle it immediately
        if (image.complete) setIsReady(true);
    }, [
        gifSrc,
        skip
    ]);
    return isReady ? gifSrc : placeholderSrc;
};
module.exports["usePreloadGif"] = $cd2e96a49affba4b$export$4b64aca38e15f2eb;

});

parcelRegister("eGUIL", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6ab3d9f83e467c30$export$8ff51aff18368071 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $6ab3d9f83e467c30$export$18d9743f01f9c283 = ()=>{
    const context = (0, $42omo.useContext)($6ab3d9f83e467c30$export$8ff51aff18368071);
    if (!context) throw new Error("useSideNavigation must be used within a SideNavigationContext.Provider");
    return context;
};
module.exports["SideNavigationContext"] = $6ab3d9f83e467c30$export$8ff51aff18368071;
module.exports["useSideNavigation"] = $6ab3d9f83e467c30$export$18d9743f01f9c283;

});

parcelRegister("8Ihu4", function(module, exports) {

let $657ffebe0e82b5d1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $657ffebe0e82b5d1$var$load("l8YLV"),
    $657ffebe0e82b5d1$var$load("6wr18"),
    $657ffebe0e82b5d1$var$load("hHrTM"),
    $657ffebe0e82b5d1$var$load("ffEVr"),
    $657ffebe0e82b5d1$var$load("7EorR"),
    $657ffebe0e82b5d1$var$load("5dBst"),
    $657ffebe0e82b5d1$var$load("Wowvf"),
    $657ffebe0e82b5d1$var$load("PkFdp")
]).then(()=>parcelRequire('hSgLQ'));

});

parcelRegister("gYqak", function(module, exports) {

let $c5b68be5e678a3d5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c5b68be5e678a3d5$var$load("6oFhK").then(()=>parcelRequire('iwt54'));

});

parcelRegister("jAO76", function(module, exports) {

let $e4384098ddb383b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e4384098ddb383b3$var$load("860dT").then(()=>parcelRequire('8KFPL'));

});

parcelRegister("28oQf", function(module, exports) {
const $a5e3205ff2d8ec91$export$38788381122702f5 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-addonengine-analytics-space-analytics';
const $a5e3205ff2d8ec91$export$6c3d789a4f56bea2 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-addonengine-analytics-moderate-space-analytics';
const $a5e3205ff2d8ec91$export$ee99bc1ad01a63ae = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-automation';
const $a5e3205ff2d8ec91$export$dad26f289a3f773e = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-blogs';
const $a5e3205ff2d8ec91$export$27d01545acc1e1ca = 'com.atlassian.confluence.extra.team-calendars:space-calendar-sidebar-link';
const $a5e3205ff2d8ec91$export$a1081c7e806b45a0 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-k15t-orderly-databases-database';
const $a5e3205ff2d8ec91$export$de45ec31104af09 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-atlassian-confluence-plugins-confluence-questions-question';
const $a5e3205ff2d8ec91$export$1b86edccef2dd51 = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-questions';
const $a5e3205ff2d8ec91$export$f618e448a4ddfafa = 'com.atlassian.confluence.plugins.confluence-frontend-support:space-tools-link';
const $a5e3205ff2d8ec91$export$9727611105a72ba4 = 'com.atlassian.plugins.atlassian-connect-plugin';
const $a5e3205ff2d8ec91$export$35d69df876e79a8b = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-shortcuts';
const $a5e3205ff2d8ec91$export$28596511f20e98f2 = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-apps';
const $a5e3205ff2d8ec91$export$1c0f21b83a6a96d6 = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-content-manager';
module.exports["ANALYTICS_KEY"] = $a5e3205ff2d8ec91$export$38788381122702f5;
module.exports["ANALYTICS_KEY_MODERATE"] = $a5e3205ff2d8ec91$export$6c3d789a4f56bea2;
module.exports["AUTOMATION_KEY"] = $a5e3205ff2d8ec91$export$ee99bc1ad01a63ae;
module.exports["BLOG_KEY"] = $a5e3205ff2d8ec91$export$dad26f289a3f773e;
module.exports["CALENDARS_KEY"] = $a5e3205ff2d8ec91$export$27d01545acc1e1ca;
module.exports["DATABASES_KEY"] = $a5e3205ff2d8ec91$export$a1081c7e806b45a0;
module.exports["QUESTIONS_KEY"] = $a5e3205ff2d8ec91$export$de45ec31104af09;
module.exports["QUESTIONS_NATIVE_KEY"] = $a5e3205ff2d8ec91$export$1b86edccef2dd51;
module.exports["SPACE_SETTINGS_KEY"] = $a5e3205ff2d8ec91$export$f618e448a4ddfafa;
module.exports["CONNECT_ADDON_KEY"] = $a5e3205ff2d8ec91$export$9727611105a72ba4;
module.exports["SHORTCUTS_KEY"] = $a5e3205ff2d8ec91$export$35d69df876e79a8b;
module.exports["APPS_KEY"] = $a5e3205ff2d8ec91$export$28596511f20e98f2;
module.exports["BULK_TOOLS_KEY"] = $a5e3205ff2d8ec91$export$1c0f21b83a6a96d6;

});

parcelRegister("bRsEt", function(module, exports) {

let $8a2ade99fbfe00e3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8a2ade99fbfe00e3$var$load("6wr18"),
    $8a2ade99fbfe00e3$var$load("ffEVr"),
    $8a2ade99fbfe00e3$var$load("Wowvf"),
    $8a2ade99fbfe00e3$var$load("c08ou")
]).then(()=>parcelRequire('99rcJ'));

});

parcelRegister("8Ai3e", function(module, exports) {

let $63ffb01b27107377$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $63ffb01b27107377$var$load("6wr18"),
    $63ffb01b27107377$var$load("ffEVr"),
    $63ffb01b27107377$var$load("8uhuz")
]).then(()=>parcelRequire('ar6Ga'));

});

parcelRegister("4vXZ9", function(module, exports) {

let $34989688401e1317$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $34989688401e1317$var$load("6wr18"),
    $34989688401e1317$var$load("ffEVr"),
    $34989688401e1317$var$load("klGUa")
]).then(()=>parcelRequire('8o2bj'));

});

parcelRegister("hXk9Y", function(module, exports) {

let $d12795b1ec9fc755$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d12795b1ec9fc755$var$load("6wr18"),
    $d12795b1ec9fc755$var$load("ffEVr"),
    $d12795b1ec9fc755$var$load("5dBst"),
    $d12795b1ec9fc755$var$load("7EorR"),
    $d12795b1ec9fc755$var$load("kZjBp")
]).then(()=>parcelRequire('1xLOH'));

});

parcelRegister("6i41U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("3AeIf", function(module, exports) {
/**
 * @generated SignedSource<<656b0d44239f7eb3a8ba9659e9762f2f>>
 * @relayHash f18661cc7a1d2d55f19018b453d74e49
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5b9f82627568e61d5a48e4bdd045a30d7fc6ac7b992beec39feead5b18838e62
const $ca580f7b974eac2e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "spaceViewsPersistence"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f18661cc7a1d2d55f19018b453d74e49",
            "id": "5b9f82627568e61d5a48e4bdd045a30d7fc6ac7b992beec39feead5b18838e62",
            "metadata": {},
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "operationKind": "query",
            "text": "query useSpaceViewsOptionsPersistenceQuery($spaceKey:String!){userPreferences{spaceViewsPersistence(spaceKey:$spaceKey)}}"
        }
    };
}();
$ca580f7b974eac2e$var$node.hash = "cc599626e8f53c4256f22a11dfce92c8";
var $ca580f7b974eac2e$export$2e2bcd8739ae039 = $ca580f7b974eac2e$var$node;
module.exports["default"] = $ca580f7b974eac2e$export$2e2bcd8739ae039;

});

parcelRegister("dedJV", function(module, exports) {

var $g46Dm = parcelRequire("g46Dm");


var $4swWN = parcelRequire("4swWN");


var $et7kG = parcelRequire("et7kG");

function $79ec0654a66dd5c6$export$8d21e34596265fa2(data) {
    if (!data || Object.keys(data).length < 1) throw new Error('Data are not available');
    // @ts-ignore - This is causing ts errors when this package is being enrolled into jira local consumption so temporarily ts ignoring this line for now
    globalThis.ATL_CONTEXT_DOMAIN = data;
}
function $79ec0654a66dd5c6$var$isValidDomainKey(domainKey) {
    if (!(0, $et7kG.AllowedDomains).includes(domainKey)) return false;
    return true;
}
function $79ec0654a66dd5c6$export$b5ce351acdc48c2a(domain, environment) {
    // Validate this is a valid domain
    if (!$79ec0654a66dd5c6$var$isValidDomainKey(domain)) throw new Error(`Domain ${domain} is not supported.
      Supported domains: ${(0, $et7kG.AllowedDomains).join(', ')}`);
    // First priority, always return the global context if the product has onboarded
    // @ts-ignore - This is causing ts errors when this package is being enrolled into jira local consumption so temporarily ts ignoring this line for now
    const data = globalThis.ATL_CONTEXT_DOMAIN;
    if (data) return data[domain];
    const [env, perimeter] = environment ?? $79ec0654a66dd5c6$export$509d18a5fd824839();
    // Second priority, return if there is a full domain override
    const override = (0, $4swWN.fullDomainOverride)[domain];
    if (override) return(// Exact match preferred
    override[perimeter]?.[env] ?? override[0, $g46Dm.COMMERCIAL][0, $g46Dm.PRODUCTION] // Fallback to mandatory commercial production
    );
    // Third priority, join the subdomain
    const tld = (0, $4swWN.domainMap)[perimeter]?.[env] ?? (0, $4swWN.domainMap)[0, $g46Dm.COMMERCIAL][0, $g46Dm.PRODUCTION];
    const subdomain = (0, $4swWN.subdomainOverride)[domain] ?? domain;
    return `${subdomain}.${tld}`;
}
function $79ec0654a66dd5c6$export$45d6512913ef41b4(domain) {
    return `${globalThis.location.protocol}//${$79ec0654a66dd5c6$export$b5ce351acdc48c2a(domain)}`;
}
function $79ec0654a66dd5c6$export$509d18a5fd824839() {
    const hostname = globalThis.location?.hostname;
    if (!hostname) // default if no location available
    return [
        (0, $g46Dm.PRODUCTION),
        (0, $g46Dm.COMMERCIAL)
    ];
    // *.atlassian-fex.com
    if (hostname.match(/atlassian-fex\.com/)) return [
        (0, $g46Dm.STAGING),
        (0, $g46Dm.FEDRAMP_FEDEX)
    ];
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (hostname.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return [
        (0, $g46Dm.STAGING),
        (0, $g46Dm.FEDRAMP_MODERATE)
    ];
    // *.atlassian-stg-fedm.net
    if (hostname.match(/atlassian-stg-fedm\.net/)) return [
        (0, $g46Dm.STAGING),
        (0, $g46Dm.FEDRAMP_MODERATE)
    ];
    // *.atlassian-us-gov-mod.com OR *.atlassian-us-gov-mod.net
    if (hostname.match(/atlassian-us-gov-mod\.(com|net)/)) return [
        (0, $g46Dm.PRODUCTION),
        (0, $g46Dm.FEDRAMP_MODERATE)
    ];
    // *.stg.atlassian.com OR *.stg.internal.atlassian.com
    if (hostname.match(/stg(\.internal)?\.atlassian\.com/)) return [
        (0, $g46Dm.STAGING),
        (0, $g46Dm.COMMERCIAL)
    ];
    // *.jira-dev.com
    if (hostname.match(/jira-dev\.com/)) return [
        (0, $g46Dm.STAGING),
        (0, $g46Dm.COMMERCIAL)
    ];
    // default fallthrough
    return [
        (0, $g46Dm.PRODUCTION),
        (0, $g46Dm.COMMERCIAL)
    ];
}
module.exports["getATLContextDomain"] = $79ec0654a66dd5c6$export$b5ce351acdc48c2a;
module.exports["getATLContextUrl"] = $79ec0654a66dd5c6$export$45d6512913ef41b4;

});

parcelRegister("4swWN", function(module, exports) {

var $g46Dm = parcelRequire("g46Dm");

const $dbc5bb16ecb06da9$export$6836b090dbaa813a = {
    [(0, $g46Dm.COMMERCIAL)]: {
        [(0, $g46Dm.STAGING)]: 'stg.atlassian.com',
        [(0, $g46Dm.PRODUCTION)]: 'atlassian.com'
    },
    [(0, $g46Dm.FEDRAMP_FEDEX)]: {
        [(0, $g46Dm.STAGING)]: 'atlassian-fex.com'
    },
    [(0, $g46Dm.FEDRAMP_MODERATE)]: {
        [(0, $g46Dm.STAGING)]: 'stg.atlassian-us-gov-mod.com',
        [(0, $g46Dm.PRODUCTION)]: 'atlassian-us-gov-mod.com'
    }
};
const $dbc5bb16ecb06da9$export$c6ab20d0ac4d06b2 = {};
const $dbc5bb16ecb06da9$export$4723232b625f823e = {
    analytics: {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'analytics.atlassian.com'
        }
    },
    // Marketing site
    confluence: {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'confluence.atlassian.com'
        }
    },
    // Atlassian design system documentation
    design: {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'design.atlassian.com'
        }
    },
    // Old staff intranet (now hello.atlassian.net)
    extranet: {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'extranet.atlassian.com'
        }
    },
    // Go links
    go: {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'go.atlassian.com'
        }
    },
    my: {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'my.atlassian.com'
        }
    },
    schema: {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'schema.atlassian.com'
        }
    },
    start: {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'start.atlassian.com',
            [(0, $g46Dm.STAGING)]: 'start.stg.atlassian.com'
        },
        [(0, $g46Dm.FEDRAMP_MODERATE)]: {
            [(0, $g46Dm.PRODUCTION)]: 'start.atlassian-us-gov-mod.com',
            [(0, $g46Dm.STAGING)]: 'start.stg.atlassian-us-gov-mod.com'
        }
    },
    surveys: {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'surveys.atlassian.com'
        }
    },
    'wac-cdn': {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'wac-cdn.atlassian.com'
        }
    },
    integrations: {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'integrations.atlassian.com'
        }
    },
    permalink: {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'permalink.atlassian.com'
        }
    },
    id: {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'id.atlassian.com',
            [(0, $g46Dm.STAGING)]: 'id.stg.internal.atlassian.com',
            [(0, $g46Dm.DEV)]: 'id.dev.internal.atlassian.com'
        },
        [(0, $g46Dm.FEDRAMP_MODERATE)]: {
            [(0, $g46Dm.PRODUCTION)]: 'id.atlassian-us-gov-mod.com',
            [(0, $g46Dm.STAGING)]: 'id.stg.atlassian-us-gov-mod.com'
        }
    },
    support: {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'support.atlassian.com'
        }
    }
};
module.exports["domainMap"] = $dbc5bb16ecb06da9$export$6836b090dbaa813a;
module.exports["subdomainOverride"] = $dbc5bb16ecb06da9$export$c6ab20d0ac4d06b2;
module.exports["fullDomainOverride"] = $dbc5bb16ecb06da9$export$4723232b625f823e;

});

parcelRegister("et7kG", function(module, exports) {
/* *NOTE*: please ensure any changes made to Perimeter and DomainKey type is copied in typings/atl-context.globals.d.ts */ const $7584f40bea5ad330$export$b450288891b9771b = [
    'admin',
    'analytics',
    'api',
    'api.media',
    'api-private',
    'as',
    'atl-global',
    'atlaskit',
    'auth',
    'automation',
    'cassi.internal',
    'cc-import-sources.services',
    'confluence',
    'confluence-chats-integr.services',
    'confluence-cloud-bamboo.internal',
    'confluence-questions.services',
    'data-portal.internal',
    'design',
    'developer',
    'extranet',
    'go',
    'id',
    'id-mail-assets',
    'integrations',
    'ja',
    'jira',
    'jsd-widget',
    'jsd-widget-staging',
    'marketplace',
    'my',
    'my-reminders.services',
    'partners',
    'permalink',
    'permalink.stg',
    'schema',
    'start',
    'support',
    'surveys',
    'team',
    'wac-cdn',
    'xxid',
    'home'
];
module.exports["AllowedDomains"] = $7584f40bea5ad330$export$b450288891b9771b;

});

parcelRegister("7xVCs", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $T1bCI = parcelRequire("T1bCI");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $T1bCI.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("aJT7b", function(module, exports) {
/* list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $002d225363d96747$var$_List({ children: children, testId: testId, xcss: xcss }, forwardedRef) {
    return(/**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss,
        "data-testid": testId,
        children: children
    }));
}
const $002d225363d96747$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $42omo.forwardRef)($002d225363d96747$var$_List);
module.exports["List"] = $002d225363d96747$export$54c2e3dc7acea9f5;

});

parcelRegister("1CdLs", function(module, exports) {
/* expandable-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6mkwk = parcelRequire("6mkwk");


var $jvL0g = parcelRequire("jvL0g");


var $6BXcn = parcelRequire("6BXcn");

const $417a895b4429e145$var$relativeStyles = {
    root: "_kqswh2mm"
}; /**
    * __ExpandableMenuItem__
    *
    * A composable component for nested menu items that can be revealed and hidden by interacting witih the parent menu item.
    *
    * Follows the [disclosure pattern](https://www.w3.org/WAI/ARIA/apg/patterns/disclosure/).
    *
    * Should be used with `ExpandableMenuItemTrigger` as the parent menu item, and children menu items should be wrapped in a `ExpandableMenuItemContent`.
    *
    * Usage example:
    * ```jsx
    * <ExpandableMenuItem>
    *   <ExpandableMenuItemTrigger>Parent menu item</ExpandableMenuItemTrigger>
    *   <ExpandableMenuItemContent>
    *     <ButtonMenuItem>Item 1</ButtonMenuItem>
    *     <ButtonMenuItem>Item 2</ButtonMenuItem>
    *   </ExpandableMenuItemContent>
    * </ExpandableMenuItem>
    * ```
    */ 
const $417a895b4429e145$export$341dea48c30b36ff = /*#__PURE__*/ (0, $42omo.forwardRef)(({ isExpanded: isExpandedControlled, isDefaultExpanded: isDefaultExpanded = false, onExpansionToggle: onExpansionToggle, children: children, dropIndicator: dropIndicator, testId: testId }, forwardedRef)=>{
    const [isExpanded, setIsExpanded] = (0, $6mkwk.default)(isExpandedControlled, ()=>isDefaultExpanded);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.IsExpandedContext).Provider, {
        value: isExpanded,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.SetIsExpandedContext).Provider, {
            value: setIsExpanded,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.OnExpansionToggleContext).Provider, {
                value: onExpansionToggle ?? null,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jvL0g.MenuListItem), {
                    ref: forwardedRef,
                    testId: testId,
                    children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                        className: (0, $gMc0m.default)([
                            dropIndicator && $417a895b4429e145$var$relativeStyles.root
                        ]),
                        children: [
                            children,
                            dropIndicator
                        ]
                    })
                })
            })
        })
    });
});
module.exports["ExpandableMenuItem"] = $417a895b4429e145$export$341dea48c30b36ff;

});

parcelRegister("YQCfa", function(module, exports) {
/* expandable-menu-item-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $aJT7b = parcelRequire("aJT7b");


var $6BXcn = parcelRequire("6BXcn");

const $73667a40c01a69a2$var$styles = {
    content: "_bozg1crf",
    collapsedContent: "_1e0cglyw"
};
const $73667a40c01a69a2$export$bd680a81504a92e9 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children }, forwardedRef)=>{
    const isExpanded = (0, $6BXcn.useIsExpanded)();
    const level = (0, $6BXcn.useLevel)();
    const hasExpanded = (0, $42omo.useRef)(false);
    const areAllAncestorsExpanded = (0, $6BXcn.useAreAllAncestorsExpanded)();
    if (!isExpanded && !hasExpanded.current) return null;
    hasExpanded.current = true;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.LevelContext).Provider, {
        value: level + 1,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.AreAllAncestorsExpandedContext).Provider, {
            value: /**
     * By combining the current ancestor and with the current menu item's state, all nested menu items will know if their
     * ancestor menu items are all expanded.
     */ areAllAncestorsExpanded && isExpanded,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aJT7b.List), {
                ref: forwardedRef,
                xcss: (0, $1bHXt.cx)($73667a40c01a69a2$var$styles.content, !isExpanded && $73667a40c01a69a2$var$styles.collapsedContent),
                children: children
            })
        })
    });
});
module.exports["ExpandableMenuItemContent"] = $73667a40c01a69a2$export$bd680a81504a92e9;

});

parcelRegister("8INvs", function(module, exports) {
/* expandable-menu-item-trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");


var $3hoG4 = parcelRequire("3hoG4");


var $ghftu = parcelRequire("ghftu");


var $6R5uz = parcelRequire("6R5uz");


var $dh538 = parcelRequire("dh538");


var $8njHX = parcelRequire("8njHX");


var $fDC7w = parcelRequire("fDC7w");


var $6BXcn = parcelRequire("6BXcn");

const $675a107b26f743ab$var$chevronDisplayCssVar = '--expandable-chevron-display';
const $675a107b26f743ab$var$providedElemBeforeDisplayCssVar = '--expandable-provided-elembefore-display';
const $675a107b26f743ab$var$wrapperStyles = {
    root: "_1mmi1txw _165nglyw",
    showProvidedElemBefore: "_1mmiglyw _165n1bgi _v9u71txw _1hl9glyw _b31z1txw _1vnl1txw _12xsglyw _p8btglyw"
};
const $675a107b26f743ab$var$nestedOpenPopupStylesOld = {
    showProvidedElemBefore: "_v9u71txw _1hl9glyw"
}; // Merge back into the `wrapperStyles` after cleanup
const $675a107b26f743ab$var$nestedOpenPopupStylesNew = {
    showProvidedElemBefore: "_1ddp1txw _pnu5glyw"
};
const $675a107b26f743ab$var$iconStyles = {
    chevron: "_1e0ciw0t _1tz3r0mg",
    providedElemBefore: "_1e0c1xb2",
    providedElemBeforeSelected: "_syazxl6c"
};
const $675a107b26f743ab$var$ExpandableMenuItemIcon = ({ iconProps: iconProps, isExpanded: isExpanded, isSelected: isSelected, providedElemBefore: providedElemBefore })=>{
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))) : (0, (/*@__PURE__*/$parcel$interopDefault($6R5uz)));
    const chevronElem = /*#__PURE__*/ (0, $l998X.jsx)(ChevronIcon, {
        ...iconProps,
        label: "",
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : undefined,
        size: "small"
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $675a107b26f743ab$var$iconStyles.chevron
                ]),
                children: chevronElem
            }),
            providedElemBefore && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $675a107b26f743ab$var$iconStyles.providedElemBefore,
                    isSelected && $675a107b26f743ab$var$iconStyles.providedElemBeforeSelected
                ]),
                children: providedElemBefore
            })
        ]
    });
};
const $675a107b26f743ab$export$fe6fe51056867f4d = (0, $3hoG4.default)(({ actions: actions, isSelected: isSelected, href: href, elemBefore: providedElemBefore, elemAfter: elemAfter, actionsOnHover: actionsOnHover, onClick: onClick, children: children, testId: testId, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const id = (0, $42omo.useId)();
    const onExpansionToggle = (0, $6BXcn.useOnExpansionToggle)();
    const isExpanded = (0, $6BXcn.useIsExpanded)();
    const setIsExpanded = (0, $6BXcn.useSetIsExpanded)();
    const itemRef = (0, $42omo.useRef)(null);
    const handleIconClick = (0, $42omo.useCallback)(()=>{
        onExpansionToggle?.(!isExpanded);
        setIsExpanded(!isExpanded);
    }, [
        isExpanded,
        onExpansionToggle,
        setIsExpanded
    ]);
    const handleMenuContentClick = (0, $42omo.useCallback)((event, analyticsEvent)=>{
        const newValue = !isExpanded;
        onClick?.(event, analyticsEvent, {
            isExpanded: newValue
        });
        onExpansionToggle?.(newValue);
        setIsExpanded(newValue);
    }, [
        onClick,
        onExpansionToggle,
        isExpanded,
        setIsExpanded
    ]);
    const isSelectable = typeof href !== 'undefined';
    (0, $fDC7w.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: Boolean(isSelectable && isSelected)
    }); // Wrapped in an IconButton if the expandable menu item trigger is selectable
    const elemBefore = isSelectable ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)($675a107b26f743ab$var$ExpandableMenuItemIcon, {
                iconProps: iconProps,
                isExpanded: isExpanded,
                isSelected: isSelected,
                providedElemBefore: providedElemBefore
            }),
        "aria-expanded": isExpanded,
        // screen readers on what will actually be expanded or collapsed. Screen readers will also use the
        // `aria-expanded` attribute to indicate the expanded state of the menu item.
        // We are not using the `aria-label` attribute here as it is not supported by the `IconButton` component.
        "aria-labelledby": id,
        // `aria-labelledby`, which will be used instead.
        label: "",
        appearance: "subtle",
        spacing: "compact",
        onClick: handleIconClick,
        interactionName: interactionName,
        testId: testId ? `${testId}--elem-before-button` : undefined
    }) : /*#__PURE__*/ (0, $l998X.jsx)($675a107b26f743ab$var$ExpandableMenuItemIcon, {
        isExpanded: isExpanded,
        isSelected: isSelected,
        providedElemBefore: providedElemBefore
    }); // For expandable menu items, we shouldn't wrap in a `li` here. The `li` is instead at a higher level (`ExpandableMenuItem`), grouping the expandable menu item trigger and its content
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: itemRef,
        className: (0, $gMc0m.default)([
            $675a107b26f743ab$var$wrapperStyles.root,
            providedElemBefore && $675a107b26f743ab$var$wrapperStyles.showProvidedElemBefore,
            (0, $dh538.fg)('platform_dst_nav4_flyout_menu_slots_close_button') ? $675a107b26f743ab$var$nestedOpenPopupStylesNew.showProvidedElemBefore : $675a107b26f743ab$var$nestedOpenPopupStylesOld.showProvidedElemBefore
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8njHX.MenuItemBase), {
            id: id,
            actions: actions,
            actionsOnHover: actionsOnHover,
            elemBefore: elemBefore,
            ariaExpanded: isExpanded,
            elemAfter: elemAfter,
            href: href,
            isSelected: isSelected,
            onClick: handleMenuContentClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            testId: testId,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
});
module.exports["ExpandableMenuItemTrigger"] = $675a107b26f743ab$export$fe6fe51056867f4d;

});

parcelRegister("7aA9P", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");

class $538583af869725c3$export$b170112dc71045f1 extends (0, $42omo.PureComponent) {
    render() {
        const props = Object.assign({}, this.props);
        if ((this.state.error || !props.src) && props.fallback) {
            if (typeof props.fallback === 'string') props.src = props.fallback;
            else if (typeof props.fallback === 'function') return props.fallback();
        }
        delete props.fallback;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
            ...props,
            alt: props.alt || '',
            onError: this.onError
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            error: false
        };
        this.onError = ()=>{
            this.setState({
                error: true
            });
        };
    }
}
$538583af869725c3$export$b170112dc71045f1.propTypes = {
    fallback: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
    ])
};
module.exports["FallbackableImage"] = $538583af869725c3$export$b170112dc71045f1;

});

parcelRegister("lfFzM", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $jMyy4 = parcelRequire("jMyy4");


var $6jrkJ = parcelRequire("6jrkJ");


var $hiC7Y = parcelRequire("hiC7Y");

const $f78b3fd6fbd1f922$export$dd53ec461ae8f03e = ()=>{
    // if the claim does not exist, we'll skip doing the actual query
    const hasSuperAdminClaim = (0, $6jrkJ.getSuperAdminClaim)();
    const { loading: loading, error: error, data: data } = (0, $jMyy4.useQueryInterop)((0, $hiC7Y.default), {
        skip: !hasSuperAdminClaim
    });
    return hasSuperAdminClaim ? {
        loading: loading,
        error: error,
        isSuperAdmin: Boolean(data?.user?.confluence?.roles?.isSuperAdmin)
    } : {
        loading: false,
        isSuperAdmin: false
    };
};
const $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a = ({ children: children })=>{
    const { isSuperAdmin: isSuperAdmin, loading: loading, error: error } = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e();
    return children({
        loading: loading,
        error: error,
        isSuperAdmin: isSuperAdmin
    });
};
$f78b3fd6fbd1f922$export$a7f16c8c21f70b7a.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["useIsSuperAdmin"] = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e;
module.exports["AdminKeyQuery"] = $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a;

});

parcelRegister("hiC7Y", function(module, exports) {
/**
 * @generated SignedSource<<744633e989b4d3d02533375405b7463f>>
 * @relayHash 0f84e07ae7daaa03ff834c7e22000d77
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78
const $55ca182de67fa1f0$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLConfluenceUserRoles",
                            "kind": "LinkedField",
                            "name": "roles",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isSuperAdmin"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "0f84e07ae7daaa03ff834c7e22000d77",
            "id": "54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78",
            "metadata": {},
            "name": "IsSuperAdminQuery",
            "operationKind": "query",
            "text": "query IsSuperAdminQuery{user:confluence_atlassianUser(current:true){id,confluence{roles{isSuperAdmin}}}}"
        }
    };
}();
$55ca182de67fa1f0$var$node.hash = "9aa53dcf116596c8f8285a3aa93878ce";
var $55ca182de67fa1f0$export$2e2bcd8739ae039 = $55ca182de67fa1f0$var$node;
module.exports["default"] = $55ca182de67fa1f0$export$2e2bcd8739ae039;

});

parcelRegister("2vuKf", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");


var $bwL2u = parcelRequire("bwL2u");

const $d03c194add2856c2$export$214964e539560671 = (0, $9zUhf.createHook)((0, $bwL2u.Store), {
    selector: (state)=>state.multiSelectMode === (0, $bwL2u.MultiSelectMode).ACTIVE
});
module.exports["useIsMultiSelectActive"] = $d03c194add2856c2$export$214964e539560671;

});

parcelRegister("bwL2u", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $647b75406606f8a7$export$630aa3bad9698e43 = /*#__PURE__*/ function(MultiSelectMode) {
    MultiSelectMode["ACTIVE"] = "active";
    MultiSelectMode["INACTIVE"] = "inactive";
    MultiSelectMode["DISABLED"] = "disabled";
    return MultiSelectMode;
}({});
const $647b75406606f8a7$var$initialState = {
    multiSelectMode: "inactive",
    selectedContent: {},
    count: 0,
    loadingDescendantIds: new Set()
};
const $647b75406606f8a7$var$actions = {
    getState: ()=>({ getState: getState })=>{
            return getState();
        },
    enterMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "active",
                selectedContent: {},
                count: 0
            });
        },
    exitMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "inactive",
                selectedContent: {},
                count: 0
            });
        },
    disableMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "disabled"
            });
        },
    getSelectedDescendantCount: (contentId)=>({ getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            return selectedContent[contentId].selectedDescendantCount;
        },
    updateTotalCount: (delta)=>({ getState: getState, setState: setState })=>{
            const { count: prevCount } = getState();
            setState({
                count: prevCount + delta
            });
        },
    // Update the selected descendant count.
    updateSelectedDescendantsCount: (contentId, descendantCount)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [contentId]: {
                    selectedDescendantCount: descendantCount,
                    deselectedChildren: selectedContent[contentId]?.deselectedChildren ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Update the parent content's deselected children array.
    updateParent: (contentId, parentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [parentId]: {
                    selectedDescendantCount: selectedContent[parentId].selectedDescendantCount,
                    deselectedChildren: new Set([
                        ...selectedContent[parentId].deselectedChildren
                    ].filter((x)=>x !== contentId)) ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    selectNestedContent: (items)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            // First element in items is the current item being selected.
            const currentItemId = items[0].id;
            const newSelectedContent = {
                ...selectedContent
            };
            for (const item of items){
                if (currentItemId === item.id && item.parentId && item.parentId in newSelectedContent) newSelectedContent[item.parentId].deselectedChildren.delete(item.id);
                newSelectedContent[item.id] = {
                    selectedDescendantCount: 0,
                    deselectedChildren: selectedContent[item.id]?.deselectedChildren ?? new Set()
                };
            }
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    incrementAncestors: (ancestorIds, currentContentSelectionCount, countToRemove)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount + currentContentSelectionCount - countToRemove + 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Decrement the selected descendant count of ancestors when a content is deselected.
    decrementAncestors: (ancestorIds, currentContentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const selectItemCount = selectedContent[currentContentId].selectedDescendantCount;
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount - selectItemCount - 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Deselects the content and its descendants, updating the selectedContent state.
    deselectNestedContent: (contentIds, parentIds)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            let newSelectedContent = {
                ...selectedContent
            };
            contentIds.forEach((contentId)=>{
                // Remove the contentId from selectedContent
                const { [contentId]: removed, ...rest } = newSelectedContent;
                newSelectedContent = rest;
                // For each parentId, update its deselectedChildren set
                parentIds.forEach((parentId)=>{
                    if (parentId in newSelectedContent) {
                        const parentContent = {
                            ...newSelectedContent[parentId]
                        };
                        if (!parentContent.deselectedChildren) parentContent.deselectedChildren = new Set();
                        parentContent.deselectedChildren.add(contentId);
                        newSelectedContent[parentId] = parentContent;
                    }
                });
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    clearSelection: ()=>({ setState: setState })=>{
            setState({
                selectedContent: {},
                count: 0
            });
        },
    addLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.add(contentId);
            setState({
                loadingDescendantIds: next
            });
        },
    removeLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.delete(contentId);
            setState({
                loadingDescendantIds: next
            });
        }
};
const $647b75406606f8a7$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $647b75406606f8a7$var$initialState,
    actions: $647b75406606f8a7$var$actions,
    name: 'contentTreeSelection'
});
const $647b75406606f8a7$export$cbc26e3dcdb786e6 = (0, $9zUhf.createHook)($647b75406606f8a7$export$390f32400eaf98c9);
const $647b75406606f8a7$export$ce1c0cba22262219 = (0, $9zUhf.createActionsHook)($647b75406606f8a7$export$390f32400eaf98c9);
module.exports["MultiSelectMode"] = $647b75406606f8a7$export$630aa3bad9698e43;
module.exports["Store"] = $647b75406606f8a7$export$390f32400eaf98c9;
module.exports["useContentTreeSelection"] = $647b75406606f8a7$export$cbc26e3dcdb786e6;
module.exports["useContentTreeSelectionActions"] = $647b75406606f8a7$export$ce1c0cba22262219;

});

parcelRegister("3qtLb", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $4VJDS = parcelRequire("4VJDS");


var $5Abqh = parcelRequire("5Abqh");


var $6mKj3 = parcelRequire("6mKj3");

const $674e09754a51af28$var$DELAY_HYRATION_ON_HOVER_FF = 'confluence_frontend_delay_hydration_on_hover';
const $674e09754a51af28$export$19ffb24f8071504 = 2;

const $674e09754a51af28$export$10d5dbd9dd81149f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-KKls",
    name: "PageTreeLoader",
    loader: async ()=>(await (parcelRequire("g4RtI"))).PageTree
});

const $674e09754a51af28$export$8ce7795bff922b41 = (0, $jmjWc.LoadableHydrateOnHover)({
    __loadable_id__: "dXqjD",
    name: "PageTreeLoaderOnHover",
    loader: async ()=>(await (parcelRequire("g4RtI"))).PageTree,
    hydrateImmediately: ()=>{
        // If page tree was not successfully rendered on server-side, hydrate immediately otherwise user will see a blank page tree
        return !(0, $5Abqh.checkSSRPartialSuccess)((0, $5Abqh.SSR_PARTIAL_COMPONENT).PageTree);
    }
});
const $674e09754a51af28$export$73500bf5f2e2b0c4 = (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $4VJDS.default).getNumber($674e09754a51af28$var$DELAY_HYRATION_ON_HOVER_FF, 0) || 0;
        $[0] = t0;
    } else t0 = $[0];
    const delayHydrationOnHoverTimeout = t0;
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, !(0, $6mKj3.expVal)("confluence_frontend_remove_hydrateonhover_pagetree", "isEnabled", false) && delayHydrationOnHoverTimeout > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($674e09754a51af28$export$8ce7795bff922b41, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($674e09754a51af28$export$10d5dbd9dd81149f, props));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
module.exports["ANIMATE_TIME_SEC"] = $674e09754a51af28$export$19ffb24f8071504;
module.exports["PageTreeLoader"] = $674e09754a51af28$export$10d5dbd9dd81149f;
module.exports["PageTreeLoaderOnHover"] = $674e09754a51af28$export$8ce7795bff922b41;
module.exports["PageTree"] = $674e09754a51af28$export$73500bf5f2e2b0c4;

});

parcelRegister("g4RtI", function(module, exports) {

let $bb4680c086e63e83$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bb4680c086e63e83$var$load("ivbae"),
    $bb4680c086e63e83$var$load("5dBst"),
    $bb4680c086e63e83$var$load("fJ83T"),
    $bb4680c086e63e83$var$load("6wr18"),
    $bb4680c086e63e83$var$load("e4XZ1"),
    $bb4680c086e63e83$var$load("5ppK3"),
    $bb4680c086e63e83$var$load("an06t"),
    $bb4680c086e63e83$var$load("ajt6g"),
    $bb4680c086e63e83$var$load("4mgLr"),
    $bb4680c086e63e83$var$load("19uFC"),
    $bb4680c086e63e83$var$load("28l1x"),
    $bb4680c086e63e83$var$load("ffEVr"),
    $bb4680c086e63e83$var$load("iNa18"),
    $bb4680c086e63e83$var$load("hogcU"),
    $bb4680c086e63e83$var$load("9jjvO"),
    $bb4680c086e63e83$var$load("hcSzd"),
    $bb4680c086e63e83$var$load("cSBzF"),
    $bb4680c086e63e83$var$load("4izLy"),
    $bb4680c086e63e83$var$load("hhss7"),
    $bb4680c086e63e83$var$load("Wowvf"),
    $bb4680c086e63e83$var$load("7EorR"),
    $bb4680c086e63e83$var$load("ltXeo")
]).then(()=>parcelRequire('bbZCI'));

});

parcelRegister("j3kZx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $748c02fb00e52ac9$export$a0aa95d2fbef03e8 = ({ sectionName: sectionName, collapsedByDefault: collapsedByDefault = false, forceExpand: forceExpand = false })=>{
    const [isExpandedManually, setIsExpandedManually] = (0, $42omo.useState)();
    const isDefaultExpanded = (0, $42omo.useMemo)(()=>$748c02fb00e52ac9$var$getExpandedStateBySpace(sectionName, collapsedByDefault), [
        sectionName,
        collapsedByDefault
    ]);
    const hasManualExpansion = isExpandedManually !== undefined;
    const isExpanded = hasManualExpansion ? isExpandedManually : forceExpand || isDefaultExpanded;
    const onExpansionToggle = (0, $42omo.useCallback)((newIsExpanded)=>{
        setIsExpandedManually(newIsExpanded);
        $748c02fb00e52ac9$var$updateExpandedStateBySpace(sectionName, newIsExpanded);
    }, [
        sectionName
    ]);
    return {
        isExpanded: isExpanded,
        onExpansionToggle: onExpansionToggle
    };
};
const $748c02fb00e52ac9$var$getExpandedStateBySpace = (sectionName, collapsedByDefault)=>{
    if ((0, $17wUi.confluenceLocalStorageInstance) && (0, $17wUi.confluenceLocalStorageInstance).doesContain((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES)) {
        const sideNavExpansionStates = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES);
        if (typeof sideNavExpansionStates[sectionName] === 'boolean') return sideNavExpansionStates[sectionName];
    }
    return !collapsedByDefault;
};
const $748c02fb00e52ac9$var$updateExpandedStateBySpace = (sectionName, isExpanded)=>{
    if (!(0, $17wUi.confluenceLocalStorageInstance)) return;
    const sideNavExpansionStates = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES) || {};
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES, {
        ...sideNavExpansionStates,
        [sectionName]: isExpanded
    });
};
module.exports["useSpacePersistentExpansion"] = $748c02fb00e52ac9$export$a0aa95d2fbef03e8;

});

parcelRegister("1I9Gw", function(module, exports) {
const $f0a04d35c062874d$export$1598149f6f3f7d46 = (spaceKey)=>{
    return spaceKey?.[0] === '~';
};
module.exports["isPersonalSpace"] = $f0a04d35c062874d$export$1598149f6f3f7d46;

});


//# sourceMappingURL=SpaceNavigationContent.3055fa09.js.map
